//React
import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';

//API
import { AccountApi, DistributorApi } from '../../apis/index.js';
//Material-UI
import Grid from '@material-ui/core/Grid';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
//Components
import MyLoading from '../../components/Loading.js';
import BasicModal, { EmailModal } from '../../components/Modal.js';
import { set } from 'lodash';

const DistributorAdminUpdate = (props) => {
  const id = props.match.params.id;

  const [account, setAccount] = useState([]);
  const [email, setEmail] = useState('');
  const [modalStatus, setModalStatus] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [emailModalStatus, setEmailModalStatus] = useState(false);
  const [emailModalContent, setEmailModalContent] = useState('');

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchAccountInfo();
  }, [id]);

  const fetchAccountInfo = async () => {
    setLoading(true);
    
    const res = await DistributorApi.getDistributorID(id);
    setLoading(false);
    
    setAccount(res.data || []);
    setEmail(res.data.email || '');
  };

  const handleValueChange = (value) => {
    setAccount((prevAccount) => ({
      ...prevAccount,
      email: value,
    }));
  };

  const handleChange = (e) => {
    setAccount({
      ...account,
      [e.target.name]: e.target.value,
    });
  };

  const setDate = (utcDate) => {
    const date = new Date(utcDate);
    date.setHours(date.getHours() + 9);
    return date.toISOString().replace('T', ' ').substring(0, 19);
  };

  const editEmail = () => {
    showEmailModalWithContent('Change Email Address');
    handleEmailModalOpen();
  };

  const updateAccount = async (e) => {
    e.preventDefault();

    if (!account.memberName) {
      showModalWithContent('Please set Account Name.');
      handleModalOpen();
      return;
    }

    if (!account.email) {
      showModalWithContent('Please set Email.');
      handleModalOpen();
      return;
    }

    const formData = new FormData();
    formData.append('email', email);
    formData.append('id', account.hospitalId);
    formData.append('memberName', account.memberName);
    formData.append('hospitalName', account.hospitalName);
    formData.append('updatebyEmail', localStorage.getItem('email'));

    setLoading(true);
    const res = await DistributorApi.updateDistributor(formData);

    if (res.statusCode === 200) {
      props.history.push('/distributorAdminList');
    } else {
      setLoading(false);
      alert(res.statusCode + '\n' + res.message);
    }
  };

  const handleEmailModalOpen = () => {
    setEmailModalStatus(true);
  };

  const handleEmailModalClose = () => setEmailModalStatus(false);

  const showEmailModalWithContent = (content) => {
    setEmailModalContent(content);
  };

  const handleModalOpen = () => {
    setModalStatus(true);
  };

  const handleModalClose = () => setModalStatus(false);

  const showModalWithContent = (content) => {
    setModalContent(content);
  };

  return (
    <div>
      <style>
        {`
        .form-control::placeholder {
          color: #B6BCC5;
        }
        `}
      </style>
      <div
        style={{
          fontWeight: '600',
          fontSize: '36px',
          color: '#495057',
          marginBottom: '20px',
        }}
      >
        EDIT DISTRIBUTOR
      </div>
      <Form onSubmit={updateAccount} onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}>
        <div style={{ display: 'flex', width: '100%', gap: '20px' }}>
          <Form.Group style={{ width: '80%' }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                paddingBottom: '5px',
                gap: '5px',
              }}
            >
              <span>Email</span>
              <button
                type="button"
                onClick={editEmail}
                style={{ padding: '0px' }}
              >
                <ModeEditOutlineOutlinedIcon
                  label="ModeEditOutlineOutlinedIcon"
                  style={{
                    color: '#495057',
                    opacity: '90%',
                    fontSize: '20px',
                  }}
                />
              </button>
            </div>
            <Form.Control
              disabled={true}
              style={{
                margin: '0px',
                color: '#B6bcd5',
              }}
              type="text"
              placeholder="Enter emial..."
              name="email"
              autoComplete="off"
              onChange={handleValueChange}
              value={email}
              maxLength={100}
            />
          </Form.Group>
          <Form.Group style={{ width: '20%' }}>
            <span>Invitation Status</span>
            <Form.Control
              disabled={true}
              style={{
                margin: '0px',
                color: '#B6bcd5',
              }}
              type="text"
              placeholder="Status"
              name="status"
              autoComplete="off"
              value={account.memberStatus}
            />
          </Form.Group>
        </div>
        <Form.Group>
          <span>Name</span>
          <span style={{ color: 'red' }}>*</span>
          <Form.Control
            style={{
              margin: '0px',
            }}
            type="text"
            placeholder="memberName"
            name="memberName"
            autoComplete="off"
            value={account.memberName}
            onChange={handleChange}
          />
        </Form.Group>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
          }}
        >
          <button
            type="button"
            onClick={() =>
              window.open('/updateHospitalAdmin/' + account.hospitalId)
            }
            style={{
              fontSize: '18px',
              fontWeight: '600',
              marginBottom: '20px',
            }}
          >
            {account.hospitalName} ({account.hospitalId})의 [Edit Hospital]
            페이지로 이동
          </button>
        </div>
        <div style={{ display: 'flex' }}>
          <Form.Group style={{ marginRight: '20px', width: '50%' }}>
            <Form.Label style={{ fontWeight: 'bold' }}>Insert Date</Form.Label>
            <div
              style={{
                border: '1px solid #3F598C',
                borderRadius: '5px',
                padding: '10px 0px 10px 10px',
                background: '#DADADA',
                minHeight: '40px',
              }}
            >
              {account.insertDate && (
                <div>{setDate(account.insertDate)} (KST)</div>
              )}
            </div>
          </Form.Group>
          <Form.Group style={{ marginLeft: '20px', width: '50%' }}>
            <Form.Label style={{ fontWeight: 'bold' }}>Insert ID</Form.Label>
            <div
              style={{
                border: '1px solid #3F598C',
                borderRadius: '5px',
                padding: '10px 0px 10px 10px',
                background: '#DADADA',
                minHeight: '40px',
              }}
            >
              {account.insertId}
            </div>
          </Form.Group>
        </div>
        <div style={{ display: 'flex' }}>
          <Form.Group style={{ marginRight: '20px', width: '50%' }}>
            <Form.Label style={{ fontWeight: 'bold' }}>Modify Date</Form.Label>
            <div
              style={{
                border: '1px solid #3F598C',
                borderRadius: '5px',
                padding: '10px 0px 10px 10px',
                background: '#DADADA',
                minHeight: '40px',
              }}
            >
              {account.insertDate && (
                <div>{setDate(account.modifyDate)} (KST)</div>
              )}
            </div>
          </Form.Group>
          <Form.Group style={{ marginLeft: '20px', width: '50%' }}>
            <Form.Label style={{ fontWeight: 'bold' }}>Modify ID</Form.Label>
            <div
              style={{
                border: '1px solid #3F598C',
                borderRadius: '5px',
                padding: '10px 0px 10px 10px',
                background: '#DADADA',
                minHeight: '40px',
              }}
            >
              {account.modifyId}
            </div>
          </Form.Group>
        </div>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          style={{ marginTop: 30 }}
        >
          <Grid>
            <button
              type="button"
              onClick={() => props.history.goBack()}
              style={{
                fontSize: '18px',
                fontWeight: '500',
              }}
            >
              BACK
            </button>
            <button
              type="submit"
              style={{
                fontSize: '18px',
                fontWeight: '500',
                color: '#3F51B5',
              }}
            >
              SAVE
            </button>
          </Grid>
        </Grid>
      </Form>
      <div style={{ display: 'none' }}>
        <BasicModal
          open={modalStatus}
          handleModalClose={handleModalClose}
          content={modalContent}
        />
        <EmailModal
          open={emailModalStatus}
          handleModalClose={handleEmailModalClose}
          content={emailModalContent}
          email={account.email}
          setEmail={setEmail}
          hospitalId={account.hospitalId}
          role={'distributor'}
        />
      </div>
      {loading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <MyLoading />
        </div>
      )}
    </div>
  );
};

export default DistributorAdminUpdate;
